export default "__VITE_ASSET__DLIXl58T__"